import type { WalletTransaction } from '../../../../queries/pxtraCard';
import { berlinYearMonth } from './format';

export type MonthGroup = {
  /** `YYYY-MM` */
  month: string;
  rows: WalletTransaction[];
  netCents: number;
  balanceAfterCents: number;
  personsTotal: number;
};

/** Rows arrive newest first; groups keep that order, and each group's balance is its newest row's. */
export const groupByMonth = (rows: WalletTransaction[]): MonthGroup[] => {
  const groups = new Map<string, MonthGroup>();
  for (const row of rows) {
    const month = berlinYearMonth(row.booked_at);
    const group = groups.get(month) ?? {
      month,
      rows: [],
      netCents: 0,
      balanceAfterCents: row.balance_after_cents,
      personsTotal: 0
    };
    group.rows.push(row);
    group.netCents += row.amount_cents;
    group.personsTotal += row.recipient_count ?? 0;
    groups.set(month, group);
  }
  return [...groups.values()];
};

/** Keeps the pager on a page that still exists after the list shrank. */
export const clampPageIndex = (pageIndex: number, itemCount: number, pageSize: number) =>
  Math.min(pageIndex, Math.max(0, Math.ceil(itemCount / pageSize) - 1));

/** Adds a month to the expanded set without touching the ones the user opened or closed. */
export const expandMonth = (expanded: ReadonlySet<string>, month: string): Set<string> =>
  new Set(expanded).add(month);
